import React, { forwardRef } from "react";
import { WindowData } from "js/components/RegularClassroomUser/utils";
import { StudentTile } from "./StudentTile";
import { StudentTileHeader } from "./StudentTile/StudentTileHeader";
import { StudentTileContent } from "./StudentTile/StudentTileContent";
import { IGetSignatureDbReturn } from "stores/signatureStore_I";
import { User } from "../utils/userUtils";
import { ClassroomDetails } from "@/stores/classroomStore_I";

interface Props {
	user: User;
	windowData: WindowData;
	deviceIndex: number;
	signatureDb: IGetSignatureDbReturn;
	isClassActive: boolean;
	classroom: ClassroomDetails;
	openP2pModal: (
		user: User,
		tabId: string | undefined,
		chromeId: string | undefined,
		windowId: string | undefined,
		isActiveTab: boolean
	) => void;
	tabItemLimit: number;
}

// forwardRef is needed by react-flip-move to work with FCs
const MonitoringClassroomUser = forwardRef<HTMLDivElement, Props>((props, ref) => (
	<StudentTile ref={ref} username={props.user.username}>
		<StudentTileHeader user={props.user} />
		<StudentTileContent {...props} canCloseTab={false} disableScreenshotRetry={true} />
	</StudentTile>
));

MonitoringClassroomUser.displayName = "MonitoringClassroomUser";

export default MonitoringClassroomUser;
